import { FC } from 'react';

import {
  ClientAccountStatusType,
  LegalClientOnboardingStatusType,
  LegalClientVersionEntity,
} from 'api/types/entity';
import { NavigationBreadcrumbsTitles } from 'components';
import { LayoutWithNavigationBreadcrumbs } from 'components/LayoutWithNavigationBreadcrumbs';
import { Form } from 'libs/form/Form';
import { useTranslation } from 'libs/i18n';
import {
  renderClientStatus,
  getVersionDate,
} from 'modules/client/common/helpers';
import { VersionView } from 'modules/client/common/views';

import { LegalClientSections, LegalClientSectionsProps } from '../components';
import { LegalClientFormType } from '../forms/legalClientForm';

export interface LegalClientVersionViewProps extends LegalClientSectionsProps {
  breadcrumbsTitles: NavigationBreadcrumbsTitles;
  versions: LegalClientVersionEntity[];
  currentOnboardingStatus?: LegalClientOnboardingStatusType;
  currentAccountStatus?: ClientAccountStatusType | null;
  initialValues?: LegalClientFormType;
  fullName: string;
  versionId: string;
  snapshotLoading?: boolean;
  onChangeVersion: (version: LegalClientVersionEntity) => void;
  onCloseVersionHistory: () => void;
}

export const LegalClientVersionView: FC<LegalClientVersionViewProps> = ({
  breadcrumbsTitles,
  versions,
  currentAccountStatus,
  currentOnboardingStatus,
  fullName,
  initialValues,
  snapshotLoading,
  versionId,
  onCloseVersionHistory,
  onChangeVersion,
  ...sectionsProps
}) => {
  const { t } = useTranslation();
  const status = currentAccountStatus || currentOnboardingStatus;

  return (
    <LayoutWithNavigationBreadcrumbs titles={breadcrumbsTitles}>
      <VersionView
        content={
          initialValues && (
            <Form
              initialReadOnly
              initialShowCopyButton
              initialValues={initialValues}
              onSubmit={() => {}}
            >
              <LegalClientSections
                hideActivitySection
                countryRiskAt={getVersionDate(versions, versionId)}
                {...sectionsProps}
              />
            </Form>
          )
        }
        loading={snapshotLoading || !initialValues}
        name={fullName}
        topContent={status && renderClientStatus({ status }, t, { size: 's' })}
        versionId={versionId}
        versions={versions}
        onChangeVersion={onChangeVersion}
        onCloseVersionHistory={onCloseVersionHistory}
      />
    </LayoutWithNavigationBreadcrumbs>
  );
};
